// extracted by mini-css-extract-plugin
var _1 = "WithdrawAmountStyle-module__account-holder-separated___adInh";
var _2 = "WithdrawAmountStyle-module__account-number___k2dRx";
var _3 = "WithdrawAmountStyle-module__account-holder-separated___adInh";
var _4 = "WithdrawAmountStyle-module__account-number___k2dRx";
var _5 = "WithdrawAmountStyle-module__add-new___BtY7p";
var _6 = "WithdrawAmountStyle-module__add-new___BtY7p";
var _7 = "WithdrawAmountStyle-module__bank-name___OCtvo";
var _8 = "WithdrawAmountStyle-module__bank-name___OCtvo";
var _9 = "WithdrawAmountStyle-module__details___Pqisv";
var _a = "WithdrawAmountStyle-module__details-fee___yIpfb";
var _b = "WithdrawAmountStyle-module__details-fee___yIpfb";
var _c = "WithdrawAmountStyle-module__fee___dI0if";
var _d = "WithdrawAmountStyle-module__headline-account___bV60M";
var _e = "WithdrawAmountStyle-module__headline-account___bV60M";
var _f = "WithdrawAmountStyle-module__input-holder___OHf9l";
var _10 = "WithdrawAmountStyle-module__input-holder___OHf9l";
var _11 = "WithdrawAmountStyle-module__part-paid-info___ENExi";
var _12 = "WithdrawAmountStyle-module__part-paid-info___ENExi";
var _13 = "WithdrawAmountStyle-module__withdraw-amount___uMFbc";
var _14 = "WithdrawAmountStyle-module__withdraw-amount___uMFbc";
export { _1 as "account-holder-separated", _2 as "account-number", _3 as "accountHolderSeparated", _4 as "accountNumber", _5 as "add-new", _6 as "addNew", _7 as "bank-name", _8 as "bankName", _9 as "details", _a as "details-fee", _b as "detailsFee", _c as "fee", _d as "headline-account", _e as "headlineAccount", _f as "input-holder", _10 as "inputHolder", _11 as "part-paid-info", _12 as "partPaidInfo", _13 as "withdraw-amount", _14 as "withdrawAmount" }
